<mat-form-field
  class="select-classic mb-[22px] w-full"
  appearance="outline"
>
  <mat-select
    (valueChange)="changed.emit($event)"
    [value]="value()"
    panelClass="single-select-overlay"
    placeholder="Select data point"
  >
    @for (dataPoint of dataPoints(); track dataPoint.name) {
      <mat-option [value]="dataPoint.name">
        {{ dataPoint.friendlyName || dataPoint.name }}
      </mat-option>
    }
  </mat-select>
  <mat-icon
    class="arrow-down"
    matSuffix
  >keyboard_arrow_down</mat-icon>
</mat-form-field>
